import { API_ADMIN_URL } from "../config";
import { getToken } from "../Utils/Auth";
import { getWithToken } from "./apiRequets";

const URL_Summary_ = "Summary";

function getAllCustomerData(): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
        const token = await getToken();
        // eslint-disable-next-line quotes
        const parameter = {};
        const response = await getWithToken(token, API_ADMIN_URL + URL_Summary_, parameter) // force break
            .catch((error: string) => reject(error));

        if (response.ok) {
            let body = await response.json();
            resolve(body);
        } else {
            reject(response.statusText);
        }
    });
}

export default { getAllCustomerData };
